import { on } from '@ngrx/store';
import * as _ from 'lodash';
import { CustomerIdentification } from '../../../types/customer-identification';
import { CustomerIdentificationInputField } from '../../../types/customer-identification-input-field';
import {
    setCustomerIdentification,
    updateCustomerIdentification,
    UpdateCustomerIdentificationProps,
} from '../../actions/customer-identification.actions';
import { FormState } from '../../state/form.state';
import { invalidateSignatures } from './form-reducer.utilities';

export function setCustomerIdentificationReducer(
    state: Readonly<FormState>,
    props: { customerIdentification: CustomerIdentification },
): Readonly<FormState> {
    return {
        ...state,
        participantCopies: { ...state.participantCopies },
        [state.selectedParticipantCopyId]: {
            ...state.participantCopies[state.selectedParticipantCopyId],
            customerIdentification: { ...props.customerIdentification },
        },
    };
}

export function updateCustomerIdentificationInputFieldReducer(
    state: Readonly<FormState>,
    props: UpdateCustomerIdentificationProps,
): Readonly<FormState> {
    const newInputField: { [key: string]: Readonly<CustomerIdentificationInputField> } = {};
    const existingKey = _.findKey(
        state.participantCopies[state.selectedParticipantCopyId].customerIdentification,
        (inputField) => inputField?.xmlId === props.xmlId,
    );
    if (typeof existingKey === 'undefined') {
        throw new Error(
            `FormReducer: updateCustomerIdentificationInputFieldReducer: Input field '${props.xmlId}' not existing while reducing action 'updateInputField'`,
        );
    }

    const existingInputField =
        state.participantCopies[state.selectedParticipantCopyId].customerIdentification[
            existingKey as keyof CustomerIdentification
        ];
    if (typeof existingInputField === 'undefined') {
        throw new Error(
            `FormReducer: updateCustomerIdentificationInputFieldReducer: Input field '${props.xmlId}' not existing while reducing action 'updateInputField'`,
        );
    }

    newInputField[existingKey] = {
        ...existingInputField,
        value: props.newValue,
    };
    const newForm: FormState = {
        ...state,
        participantCopies: {
            ...state.participantCopies,
            [state.selectedParticipantCopyId]: {
                ...state.participantCopies[state.selectedParticipantCopyId],
                customerIdentification: {
                    ...state.participantCopies[state.selectedParticipantCopyId].customerIdentification,
                    ...newInputField,
                },
            },
        },
    };
    return props.invalidateSignatures ? invalidateSignatures(newForm) : newForm;
}

export const customerIdentificationReducer = [
    on<FormState, Array<typeof setCustomerIdentification>>(setCustomerIdentification, setCustomerIdentificationReducer),
    on<FormState, Array<typeof updateCustomerIdentification>>(
        updateCustomerIdentification,
        updateCustomerIdentificationInputFieldReducer,
    ),
];
